import {UWM_INIT_MARKET_LOCALE} from '@/consts/eventTypes';
import type {BadgesData} from '@/types/loyalty/badgesData';

type MockEventPayload = Record<string, unknown>;

const _dispatchCustomEvent = (command: string, payload: MockEventPayload) => {
    if (!command) {
        return undefined;
    }

    const customEvent = new CustomEvent('mockCommand', {
        detail: {
            command,
            payload,
        },
    });
    document.dispatchEvent(customEvent);
};

const dispatchMarketLocaleEvent = (payload: {
    marketCode?: string;
    languageCode?: string;
    badgesConfiguration: BadgesData;
}) =>
    _dispatchCustomEvent(UWM_INIT_MARKET_LOCALE, {
        marketCode: payload.marketCode ?? 'uat',
        languageCode: payload.languageCode ?? 'en',
        badgesConfiguration: payload.badgesConfiguration,
    });

const dispatchers = {
    dispatchMarketLocaleEvent,
};

// @ts-expect-error
window.dispatchers = dispatchers;

export default dispatchers;
